import COLORS from './colors';

export interface TypeActe {
  key: string;
  text: string;
  value: string;
  icon: string;
  statsColor: string;
  textColor: string;
}

const TYPES_ACTES: TypeActe[] = [
  {
    key: 'naissance',
    text: 'Naissances',
    value: 'naissance',
    icon: 'Baby',
    statsColor: COLORS.LightBlueCardColor,
    textColor: COLORS.BlueTextColor,
  },
  {
    key: 'reconnaissance',
    text: 'Reconnaissances',
    value: 'reconnaissance',
    icon: 'UserCheck',
    statsColor: COLORS.GreenCardColor,
    textColor: COLORS.GreenTextColor,
  },
  {
    key: 'mariage',
    text: 'Mariages',
    value: 'mariage',
    icon: 'Heart',
    statsColor: COLORS.PinkCardColor,
    textColor: COLORS.PinkTextColor,
  },
  {
    key: 'deces',
    text: 'Décès',
    value: 'deces',
    icon: 'Cross',
    statsColor: COLORS.LightGreyCardColor,
    textColor: COLORS.GreyTextColor,
  },
  {
    key: 'decision',
    text: 'Décisions',
    value: 'decision',
    icon: 'BookmarkCheck',
    statsColor: COLORS.MarinBlueCardColor,
    textColor: COLORS.MarinBlueTextColor,
  },
  {
    key: 'pacs',
    text: 'PACS',
    value: 'pacs',
    icon: 'Users',
    statsColor: COLORS.PurpleCardColor,
    textColor: COLORS.PurpleTextColor,
  },
  {
    key: 'mention',
    text: 'Mentions',
    value: 'mention',
    icon: 'FileText',
    statsColor: COLORS.OrangeCardColor,
    textColor: COLORS.OrangeTextColor,
  },
];

export const TYPES_ACTES_OPTIONS = [
  { key: 'all', text: 'Tous les types', value: '' },
  ...TYPES_ACTES.map(({ key, text, value }) => ({ key, text, value })),
];

export default TYPES_ACTES;
